import React from 'react'

type SVGIconProps = {
  iconId: SVGIconType
  size: string | number
  className?: string
}

export const SVGIcon = (props: SVGIconProps) => {
  const { className, size, iconId } = props
  return (
    <svg
      className={className || ''}
      width={size}
      height={size}
      aria-hidden="true"
    >
      <use xlinkHref={`#icon--${iconId}`} />
    </svg>
  )
}

export const iconIds = [
  'arrow',
  'bookmark-full',
  'bookmark-ghost',
  'checkmark',
  'chevron-down',
  'chevron-right',
  'close',
  'concept',
  'delete',
  'edit',
  'filter',
  'info-circle',
  'play',
  'print',
  'search',
  'settings',
  'share',
  'user',
  'user2',
] as const

export const thinIconIds = ['globe', 'knife', 'pan', 'pear-carrot'] as const

export const socialIconIds = [
  'facebook',
  'instagram',
  'twitter-x',
  'youtube',
] as const

export const rteIconIds = ['rte-ul', 'rte-clear'] as const

export const hexagonIconIds = [
  'hexagon-full',
  'hexagon-ghost-thin',
  'hexagon-sliced-closed-bold',
  'hexagon-sliced-closed-thin',
  'hexagon-sliced-open',
  'hexagon-sliced-open-bold',
  'hexagon-sliced-open-thin',
] as const

export const categoryIconIds = [
  'category-dairy',
  'category-fish',
  'category-flower',
  'category-fruit',
  'category-game',
  'category-grains',
  'category-meat',
  'category-mushroom',
  'category-peanut',
  'category-potato',
  'category-poultry',
  'category-seaweed',
  'category-shellfish',
  'category-vegetable',
] as const

export const allergenIconIds = [
  'allergen-celery',
  'allergen-egg',
  'allergen-fish',
  'allergen-gluten',
  'allergen-lactose',
  'allergen-lupine',
  'allergen-milk',
  'allergen-mollusks',
  'allergen-mustard',
  'allergen-nuts',
  'allergen-peanuts',
  'allergen-pescotarian',
  'allergen-sesame',
  'allergen-shellfish',
  'allergen-soy',
  'allergen-sulphur-dioxide',
  'allergen-vegan',
  'allergen-vegetarian',
] as const

export type IconType = (typeof iconIds)[number]
export type SocialIconType = (typeof socialIconIds)[number]
export type ThinIconType = (typeof thinIconIds)[number]
export type RTEIconType = (typeof rteIconIds)[number]
export type HexagonIconType = (typeof hexagonIconIds)[number]
export type CategoryIconType = (typeof categoryIconIds)[number]
export type AllergenIconType = (typeof allergenIconIds)[number]
export type SVGIconType =
  | IconType
  | SocialIconType
  | ThinIconType
  | RTEIconType
  | HexagonIconType
  | CategoryIconType
  | AllergenIconType
